//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 10px;
    & h4 {
        margin: 0;
        margin-bottom: 15px;
        font-size: 16px;
    }
`;
export const SearchTeacher = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    width: 360px;
    height: 100%;
`;
export const TextInputTeacher  = styled.div`
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    min-width: 500px;
    & *:last-child label {
        font-size: 14px;
    }
`;
export const SearchButtonTeacher = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    & *[data-role="button"] {
        width: 100%;
    }
`;
export const DividerSearchTeacher = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 115px;
    margin: 0 25px;
    gap: 10px;
    &::after {
        content: "";
        border: 1px solid var(--purple-4);
        height: 100%;
    }
`;